import React from 'react';
import './Sidebar.css';
import CustomSideBar from '../../../common/components/Sidebar/Sidebar';
import Header from '../../../common/components/Header/Header';

const Sidebar = ({ show, Component }) => {
  return (
    <div className="bg-grey-950 relative h-full overflow-auto font-roboto text-sm font-normal m-0 p-0">
      <div className=" min-h-screen flex pt-17 md:pt-0">
        <CustomSideBar />
        <div className="flex-1  w-full widhtMd max-screen">
          <Header />

          <div className="flex-1 pb-8 flex-row w-full relative">
            <div>
              <Component />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Sidebar;
